import React from "react";
import "./ripple.css";
import moment from "moment";
import {  Tooltip } from "flowbite-react";
import { HiExclamationCircle, HiLightningBolt } from "react-icons/hi";


const COST_BREAKDOWN_HEIGHT = 22;
const COST_BREAKDOWN_PADDING = 8;
const COST_BREAKDOWN_LINE_PADDING = 2;

const numberWithCommas =(x: any) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


const DependencyComponent = ({
  dependencies=[],
  sim_flag,
  ...restProps
}) => {
  if(!dependencies.length) return null

  let isImapactPositive = true

  dependencies.forEach(dep=>{
    if((dep?.impact < 0|| dep?.impact === 0) && !sim_flag){
      isImapactPositive = false
    }
    if((dep?.sim_impact < 0|| dep?.sim_impact === 0) && sim_flag){
      isImapactPositive = false
    }
  })
  
  return (
    <div
      className={`absolute top-[-5px] left-[-4px] z-[9999] rounded  p-1`}
    >
      <Tooltip 
        trigger={'hover'} 
        content={
          <div className="w-[300px] flex flex-col gap-2 p-2 animate-fadeIn">
            
            {isImapactPositive && dependencies.map(dep => {
              if((!dep?.impact || dep?.impact === 0) && !sim_flag) return null;
              if((!dep?.sim_impact || dep?.sim_impact === 0) && sim_flag) return null;
              
              const delayDays = Math.abs(sim_flag ? dep?.sim_impact : dep?.impact);
              
              return (
                <div className="border-l-4 border-red-600 p-2 rounded bg-red-100 shadow dark:bg-red-900/60 dark:border-red-500">
                  <div className="flex items-center text-red-800 dark:text-red-300">
                    <svg className="w-5 h-5 mr-2 flex-shrink-0 text-red-600 dark:text-red-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                    </svg>
                    <span>This project is delayed by <span className="inline-block px-2 py-0.5 bg-red-200 text-red-900 font-bold rounded dark:bg-red-700 dark:text-red-100">{delayDays} days</span> due to <strong className="underline decoration-2 decoration-red-400">{dep?.project_name}</strong></span>
                  </div>
                </div>
              );
            })}
            
            {/* Only show dependency list if delay message is not shown */}
            {!isImapactPositive && (
              <div className="border-l-4 border-blue-600 p-2 rounded bg-blue-100 shadow dark:bg-blue-900/60 dark:border-blue-500">
                <div className="flex items-center text-blue-800 dark:text-blue-300">
                  <svg className="w-5 h-5 mr-2 flex-shrink-0 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z" clipRule="evenodd"></path>
                  </svg>
                  <div>
                    <span className="font-medium">This project depends on:</span>
                    <div className="mt-1 flex flex-wrap gap-1">
                      {dependencies.map(dep => {
                        if(!dep?.project_name) return null;
                        return (
                          <span className="inline-block px-2 py-0.5 bg-blue-200 text-blue-900 font-medium rounded-md dark:bg-blue-700 dark:text-blue-100">
                            {dep?.project_name}
                          </span>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        }
        className="tooltip-enhanced"
      >
        <HiExclamationCircle 
          className={!isImapactPositive 
            ? `text-green-500` 
            : `text-red-500`} 
          size={19} 
        />
      </Tooltip>
    </div>
  );
}


const CostBreakdown = ({
  projectCost,
  simulationCost=0,
  width,
  ...restProps
}) => {
  
  const widthWithoutPadding = Number(width) - COST_BREAKDOWN_LINE_PADDING;
  // const isPositive = simulationCost < 0;
   const isPositive = projectCost >= simulationCost;
  // const costPercentage =!isPositive ? Math.abs(duration / sim_data.duration) : Math.abs(duration / (sim_data.duration+duration));
  const costPercentage =!isPositive ? Math.abs(simulationCost / projectCost - 1) : Math.abs(-simulationCost / (projectCost+simulationCost) - 1);
  const costWidth = costPercentage * widthWithoutPadding;
  const simulationPercentage = 1 - costPercentage;
  const simulationWidth = simulationPercentage * widthWithoutPadding;

  const handleClick = () =>{
    // alert()
  }
  
  return (
    <div
      className={`absolute top-[40px] !right-1 z-[9999] rounded ${isPositive ? "bg-green-700" :"bg-red-700" } p-1`}
      style={{
        bottom: -(COST_BREAKDOWN_PADDING + COST_BREAKDOWN_HEIGHT),
        height: COST_BREAKDOWN_HEIGHT,
        width:"100% !important",
      }}
      title={`Live : $${numberWithCommas(projectCost)} 
Simulation : $${numberWithCommas(simulationCost)}`}
      onClick={handleClick}
    >
      {"$"}
      {/* <CostBreakdownLine
        color="#1A56DB"
        value={`$ ${projectCost}`}
        width={`${costWidth}%`}
      />
      <div style={{ width: COST_BREAKDOWN_LINE_PADDING }} />
      {simulationCost ? <CostBreakdownLine
        color={isPositive ? "#3BAA53" : "#B67575"}
        value={`$ ${simulationCost}`}
        width={`${simulationWidth}%`}
      /> : ""} */}
    </div>
  );
}


const CostBreakdownLine = ({
  color,
  value,
  width,
}) => {
const verticalLine = (
  <div style={{ backgroundColor: color, height: "100%", width: "1px" }} />
);

return (
  <div
    className="flex items-center relative"
    style={{
      height: "100%",
      width,
    }}
  >
    {verticalLine}
    <div
      className="flex-1"
      style={{ backgroundColor: color, height: "1px" }}
    />
    {verticalLine}
    <div className="absolute" style={{ left: 4, top: 12 }}>
      {numberWithCommas(value)}
    </div>
  </div>
);
}

// Helper function to get progress bar color based on completion percentage
const getProgressColor = (progress) => {
  if (progress < 25) return { bg: '#64748b', text: '#f8fafc', label: 'Early Stage' }; // gray
  if (progress < 50) return { bg: '#fb923c', text: '#7c2d12', label: 'In Progress' }; // orange
  if (progress < 75) return { bg: '#facc15', text: '#713f12', label: 'Advanced' }; // yellow
  return { bg: '#4ade80', text: '#14532d', label: 'Near Completion' }; // green
};

// Progress bar legend component
export const ProgressLegend = () => {
  return (
    <div className="absolute bottom-5 right-3 z-50 flex items-center gap-2.5 p-3 rounded-md bg-[rgba(30,41,59,0.85)] backdrop-blur-sm shadow-md border border-slate-700/20">
      {[15, 35, 65, 85].map(progress => {
        const { bg, label } = getProgressColor(progress);
        return (
          <div key={label} className="flex items-center">
            <div 
              className="w-3 h-3 rounded-sm mr-1" 
              style={{ backgroundColor: bg }} 
            />
            <span className="text-white text-xs whitespace-nowrap">{label}</span>
          </div>
        );
      })}
    </div>
  );
};

const ItemRender = ({ item, itemContext, getItemProps, sim_flag, handleProjectClick, updateXarrow }) => {
  
  const borderColor = "#AB5D5D";
  const customClass = "ripple";
  const progressPercentage = Math.min(100, Math.max(0, item.complete));
  const progressColors = getProgressColor(progressPercentage);
  
  // Get the width of the item
  const itemWidth = itemContext.dimensions.width;

  return (
    <div
      {...getItemProps({
        style: {
          backgroundColor: "#1B263C",
          border: `1px solid ${borderColor}`,
          borderRadius: "4px",
          lineHeight: "0",
          marginTop: "30px",
          position: "relative",
          minWidth: "20px",
          overflow:"hidden"
        },
        onDoubleClick: () => {
          if(typeof handleProjectClick === "function"){
            handleProjectClick(item.project_id)
          }
        },
        className: `group StatusBoxes !h-[60px] flex justify-center flex-col text-white !leading-none px-4 !bg-[#1B263C] relative !z-0 hover:overflow-visible shadow-md hover:shadow-lg transition-shadow duration-300`,
        
      })}
      id={item.project_id}
    >
      {/* New Modern Progress Bar with Gradient Background */}
      <div className="absolute bottom-0 left-0 h-1 w-full bg-gray-700 bg-opacity-50 overflow-hidden">
        <div 
          className="h-full transition-all duration-300 ease-in-out"
          style={{ 
            width: `${progressPercentage}%`,
            background: `linear-gradient(90deg, ${progressColors.bg}80 0%, ${progressColors.bg} 100%)`,
            boxShadow: `0 0 4px ${progressColors.bg}`
          }}
        />
      </div>
      
      {/* For wider items - always visible percentage indicator */}
      {itemWidth >= 120 && (
        <div
          className="text-[10px] absolute right-2 top-1 z-20 font-semibold px-1.5 py-0.5 rounded shadow-sm"
          style={{ 
            backgroundColor: progressColors.bg,
            color: progressColors.text
          }}
        >
          {Math.floor(progressPercentage)}%
        </div>
      )}

      {/* Project info content */}
      <div className="relative z-10 pb-2">
        <Tooltip trigger={'hover'} content={
          <div>
            <div>Stage: {item?.stage}</div>
            <div>{itemContext.title}</div>
            <div>{moment(item.start).format("MMM DD")} - {moment(item.end).format("MMM DD")}</div>
            <div>Progress: {Math.floor(Number(item.complete))}%</div>
          </div>
        }>
          <div className="flex flex-col w-full" style={{ minWidth: 0 }}>
            <div className="uppercase mb-1 truncate text-[#2E68E8] text-[9px] flex items-center" style={{ minWidth: 0 }}>
              <span className="truncate">Stage: {item?.stage}</span>
              
              {/* For smaller items - percentage indicator only visible on hover, positioned after stage text */}
              {itemWidth < 120 && (
                <div
                  className="ml-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 px-1.5 py-0.5 rounded shadow-sm whitespace-nowrap text-[10px] font-semibold"
                  style={{ 
                    backgroundColor: progressColors.bg,
                    color: progressColors.text
                  }}
                >
                  {Math.floor(progressPercentage)}%
                </div>
              )}
            </div>
            
            <div className="mb-1 dark:text-white text-gray-800 truncate overflow-ellipsis pr-4">
              {itemContext.title}
            </div>
            
            <div className="dark:text-[#8C909B] text-gray-500 truncate" style={{ fontSize: "10px" }}>
              {moment(item.start).format("MMM DD")} - {moment(item.end).format("MMM DD")}
            </div>
          </div>
        </Tooltip>
      </div>
      
      <div className="z-20">
        {sim_flag && (<CostBreakdown 
            {...item}
            projectCost={item.project_cost}
            simulationCost={item.simulation_cost}
            width={"100"}
          />)}
          <DependencyComponent {...item} sim_flag={sim_flag} />
      </div>
    </div>
  );
};

export default ItemRender;
